import { styled }from 'stitches.config'
import { Text } from 'components/Text'

export const CompareRoot = styled('div', {
  width: '100%',
  background: '$secondary-150',
  paddingTop: '40px',
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  gap: '$3',
  zIndex: 1,
  '@bp2': {
  paddingBottom: '40px',
    gap: '$6',
  },
})

export const SectionTitle = styled(Text, {
  paddingBottom: '24px',
  width: '100%',
  maxWidth: '320px',
  margin: 'auto',
  '@bp2': {
    maxWidth: 'none',
  },
  variants: {
    size: {
      'h1': {
        fontSize: '$h2',
        '@bp2': {
          fontSize: '$h1',
        },
      }
    }
  }
})

export const TableContainer = styled('div', {
  position: 'relative',
  zIndex: '1',
  display: 'none',
  '@bp2': {display: 'block'}
})

export const BrandColumn = styled('th', {
  width: '25%',
})

export const ThemColumn = styled('th', {
  width: '40%',
  textAlign: 'left',
})

export const UsColumn = styled('th', {
  textAlign: 'left',
  width: '35%',
})

export const Table = styled('table', {
  borderCollapse: 'collapse',
  position: 'relative',
  width: '100%',
  maxWidth: '1100px',
  margin: 'auto',
})

export const Row = styled('tr', {
  borderTop: '2px solid $quaternary-200 !important',
  height: '104px'
})

export const CompareImageWrapper = styled('div', {
  postition: 'relative',
  width: '50px',
  margin: '18px auto',
  '@bp2': {
    margin: 'auto',
    position: 'absolute',
    top: '-10px',
    left: '0',
    right: '-14px',
    width: '220px',
  },
})

export const BlobRectangleWrapper = styled('div', {
  position: 'absolute',
  top: '-38px',
  left: '710px',
  right: '0px',
  margin: 'auto',
  width: '460px',
  display: 'none',
  '@bp3': {display: 'block'}
})

export const Blob5Wrapper = styled('div', {
  position: 'absolute',
  left: '0',
  top: '-30px',
  width: '140px',
  zIndex: '0',
  display: 'none',
  '@bp2': {display: 'block'}
})

export const Blob6Wrapper = styled('div', {
  position: 'absolute',
  bottom: '80px',
  right: '0px',
  Zindex: '0',
  width: '80px',
  display: 'none',
  '@bp2': {display: 'block'}
})

export const MobileWrapper = styled('div', {
  display: 'block',
  '@bp2': {display: 'none'},

  '& .slick-list': {
    zIndex: 1,
  },

  '& .slick-dots': {
    top: '-40px',
    zIndex: 0,
  },

  '& .slick-dots li button:before': {
    fontSize: '12px'
  },

  '& .slick-dots li.slick-active button:before': {
    color: '$primary-450',
    opacity: 1
  }
})

export const FoodWrapper = styled('div', {
  margin: 'auto',
  width: '100%',
  maxWidth: '220px',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  gap: '$2',
  variants: {
    type: {
      wfr: {
        gap: '$1',
      }
    }
  }
})

export const FoodImage = styled('div', {
  margin: 'auto',
  width: '110px'
})

export const CarouselItem = styled('div', {
})
